import moment from "moment";
import { useState } from "react";
import { getActiveTasks } from "../../../services/aws/ecs";

/**
 * Custom hook for managing AWS ECS tasks
 *
 * @returns {Object} Hook methods and state
 * @returns {Array} .tasks - List of active tasks with parsed dates
 * @returns {Function} .fetchActiveTasks - Function to fetch active tasks for a cluster
 *
 * @example
 * const { tasks, fetchActiveTasks } = useTasks();
 * await fetchActiveTasks('my-cluster');
 */
const useTasks = () => {
  const [tasks, setTasks] = useState([]);

  const refreshTasks = async (cluster) => {
    const activeTasksRes = await getActiveTasks(cluster);
    const activeTasksJson = await activeTasksRes.json();

    console.log("Active Tasks:", activeTasksJson);
    
    // Map tasks to update start_time to a Date object
    const updatedTasks = activeTasksJson.tasks.map((task) => ({
      ...task,
      start_time: new Date(task.start_time),
      start_date: moment(task.start_date, "DD-MM-YYYY").toDate(),
      end_date: moment(task.end_date, "DD-MM-YYYY").toDate(),
    }));
    setTasks(updatedTasks);
  };

  return {
    tasks,
    refreshTasks,
  };
};

export default useTasks;
